import { c as _c } from "react/compiler-runtime";
import type { Table } from '@tanstack/react-table';
import { uniq } from 'es-toolkit';
import { Fragment } from 'react';
import { Select, SelectContent, SelectGroup, SelectItem, SelectSeparator, SelectTrigger, SelectValue } from '@/components/ui/select';
function SizeSelectItem(t0) {
  const $ = _c(5);
  const {
    size
  } = t0;
  const t1 = String(size);
  let t2;
  if ($[0] !== size) {
    t2 = size.toLocaleString("en-US");
    $[0] = size;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = <SelectItem className="pr-4 text-xs tracking-[.03em] tabular-nums" value={t1}>{t2}</SelectItem>;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
export function TablePaginationSizeSelect(t0) {
  const $ = _c(38);
  const {
    table,
    sizes,
    value: pageSize
  } = t0;
  let T0;
  let T1;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] !== pageSize || $[1] !== sizes || $[2] !== table) {
    let t9;
    if ($[13] !== sizes) {
      t9 = n => !sizes.includes(n) && n > Math.min(...sizes);
      $[13] = sizes;
      $[14] = t9;
    } else {
      t9 = $[14];
    }
    const itemsNum = uniq([table.getFilteredRowModel().rows.length]).filter(Boolean).filter(t9);
    const hasPageSizeItem = [...sizes, ...itemsNum].includes(pageSize);
    const selectItems = [...sizes, ...(hasPageSizeItem ? [] : [pageSize]), ...itemsNum].map(_temp);
    T1 = Select;
    t5 = String(pageSize);
    t6 = selectItems;
    if ($[15] !== table) {
      t7 = e => {
        table.setPageSize(Number(e));
      };
      $[15] = table;
      $[16] = t7;
    } else {
      t7 = $[16];
    }
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <SelectTrigger aria-label="pagination size" className="h-5! w-[unset] gap-0 px-2 py-0 text-xs tracking-[.03em] tabular-nums"><SelectValue placeholder="Select" /></SelectTrigger>;
      $[17] = t8;
    } else {
      t8 = $[17];
    }
    T0 = SelectContent;
    t1 = "item-aligned";
    let t10;
    if ($[18] !== sizes) {
      t10 = sizes.map(_temp2);
      $[18] = sizes;
      $[19] = t10;
    } else {
      t10 = $[19];
    }
    if ($[20] !== t10) {
      t2 = <SelectGroup>{t10}</SelectGroup>;
      $[20] = t10;
      $[21] = t2;
    } else {
      t2 = $[21];
    }
    if ($[22] !== hasPageSizeItem || $[23] !== pageSize) {
      t3 = !hasPageSizeItem ? <Fragment><SelectSeparator /><SelectGroup>{[pageSize].map(_temp3)}</SelectGroup></Fragment> : null;
      $[22] = hasPageSizeItem;
      $[23] = pageSize;
      $[24] = t3;
    } else {
      t3 = $[24];
    }
    t4 = itemsNum.length > 0 ? <Fragment><SelectSeparator /><SelectGroup>{itemsNum.map(_temp4)}</SelectGroup></Fragment> : null;
    $[0] = pageSize;
    $[1] = sizes;
    $[2] = table;
    $[3] = T0;
    $[4] = T1;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    T0 = $[3];
    T1 = $[4];
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
    t7 = $[11];
    t8 = $[12];
  }
  let t9;
  if ($[25] !== T0 || $[26] !== t1 || $[27] !== t2 || $[28] !== t3 || $[29] !== t4) {
    t9 = <T0 position={t1}>{t2}{t3}{t4}</T0>;
    $[25] = T0;
    $[26] = t1;
    $[27] = t2;
    $[28] = t3;
    $[29] = t4;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  let t10;
  if ($[31] !== T1 || $[32] !== t5 || $[33] !== t6 || $[34] !== t7 || $[35] !== t8 || $[36] !== t9) {
    t10 = <T1 value={t5} items={t6} onValueChange={t7}>{t8}{t9}</T1>;
    $[31] = T1;
    $[32] = t5;
    $[33] = t6;
    $[34] = t7;
    $[35] = t8;
    $[36] = t9;
    $[37] = t10;
  } else {
    t10 = $[37];
  }
  return t10;
}
function _temp4(size_2) {
  return <SizeSelectItem key={size_2} size={size_2} />;
}
function _temp3(size_1) {
  return <SizeSelectItem key={size_1} size={size_1} />;
}
function _temp2(size_0) {
  return <SizeSelectItem key={size_0} size={size_0} />;
}
function _temp(size) {
  return {
    label: size.toLocaleString("en-US"),
    value: String(size)
  };
}